var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.02344 8.61719C4.20483 8.5809 4.40467 8.63529 4.5498 8.74414C5.31168 9.30642 6.21884 9.59668 7.16211 9.59668C8.10538 9.59668 9.01254 9.30643 9.77441 8.74414C9.91955 8.63529 10.1194 8.59906 10.3008 8.61719C11.7518 8.81683 13.0396 9.63277 13.874 10.8662C14.0372 11.102 14.1822 11.3559 14.291 11.6279C14.3454 11.7367 14.3278 11.8639 14.2373 11.9727C14.0922 12.2266 13.9284 12.4624 13.7471 12.6982C13.4932 13.0428 13.2032 13.3514 12.9131 13.6416C12.6591 13.8955 12.3684 14.1495 12.0781 14.3672C10.645 15.4375 8.92133 16 7.14355 16C5.36595 15.9999 3.64293 15.4374 2.20996 14.3672C1.91968 14.1314 1.62896 13.8956 1.375 13.6416C1.06668 13.3514 0.794919 13.0429 0.541016 12.6982C0.377753 12.4806 0.195918 12.2266 0.0507812 11.9727C-0.00354872 11.8638 -0.0211724 11.7367 0.0332031 11.6279C0.142009 11.3741 0.286994 11.102 0.450195 10.8662C1.26645 9.63277 2.57236 8.81682 4.02344 8.61719ZM7.16211 0C9.44781 2.91817e-05 11.3164 1.86859 11.3164 4.1543C11.3164 6.43996 9.44778 8.30856 7.16211 8.30859C4.87641 8.30859 3.00786 6.43998 3.00781 4.1543C3.00781 1.86857 4.87638 0 7.16211 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.b43ca7f8db3978aece27a1c72f189e59.svg";
export { ForwardRef as ReactComponent };